<template>
    <v-card>
        <v-card-title class="accent white--text title">
            Energy profile
        </v-card-title>
    <v-layout row wrap>



        <v-flex xs6 v-if="thisYearPower" >
            <value-box :value="thisYearPower" unit="kWh" title="YTD Energy Consumption : This Year" icon="fa-bolt"
                       icon-size="40" icon-class="mr-4"></value-box>
        </v-flex>
        <v-flex xs6 v-if="thisMonthPower">
            <value-box :value="thisMonthPower" unit="kWh" title="MTD Energy Consumption This Month" icon="fa-bolt"
                       icon-size="40" icon-class="mr-4"></value-box>
        </v-flex>

        <v-flex xs12>
            <vue-plotly v-if="powerYearData" :data="powerYearData" :layout="layout5" :options="options5"/>
        </v-flex>
        <v-flex xs12 v-if="!profileOnly">
            <vue-plotly v-if="heatmapData" :data="heatmapData" :layout="layoutHeatmap" :options="options6"/>
        </v-flex>
    </v-layout>
    </v-card>
</template>

<script>

    import ValueBox from './ValueBox'
    import VuePlotly from './VuePlotly'
    import {callAPI} from '../helper'
    import moment from 'moment'

export default {
  name: 'YearlyEnergyProfile',
  components: {VuePlotly,ValueBox},
    props: {
        profileOnly: {type:Boolean, default: false},
    },
    computed:{
        facilityName(){
            return this.$store.state.pointsListStore.pointsList.facility_name;
        },
        oatVar(){
            if(this.facilityName==="CRP"){
                return 'Temperature';
            } else {
                return 'Outdoor_Temperature';
            }

        },
    },
  data () {
      return {
          dateRange:[moment().subtract(5, "years").startOf('year').format('YYYY-MM-DD HH:mm'),moment().format('YYYY-MM-DD HH:mm')],
          thisMonthPower:null,
          thisYearPower:null,
          data3:null,
          data4:null,
          powerYearData:null,
          heatmapData:null,
          options3: {},
          options4: {},
          options5: {},
          options6: {},
          layout5: {
              title: 'Energy Profile',
              hovermode: 'closest',
              showlegend: true,
              xaxis: {
                  title: 'Month',
                  categoryorder:'array',
                  range: [0, 11],
                  categoryarray:[ "January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December" ]
              },
              yaxis: {
                  title: 'Energy consumption (kWh)'
              },
          },
          layoutHeatmap: {
              title: 'Outdoor Temperature Heatmap (°C)',
              autosize: true,
              hovermode: 'closest',
              height:300,
              margin: {
              },
              yaxis: {
                  title: 'Year',
                  categoryorder:'array',
                  autotick: false,
                  categoryarray:[]
              },
              xaxis: {
                  title: 'Month',
              }},
      }
  },
    methods:{
        addArrays(ar1, ar2){
            let ar3 = [];
            for(let i in ar1)
                ar3.push(ar1[i] + ar2[i]);
            return ar3;
        }
    },
    mounted(){
      let me=this;
        let promises=[];
        for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
            let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
            if(equip.equipment_type==='chiller'){
                promises.push(callAPI('data/',
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'equipment_name': equip.equipment_name,
                        'agg': 'M',
                        'agg_op': 'sum',
                        'date_range':me.dateRange,
                        'sensor_names': ['Comp_Power']
                    }
                ))
            } else if(equip.equipment_type==='pump'&&me.facilityName!=="CRP"){
                promises.push(callAPI('data/',
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'equipment_name': equip.equipment_name,
                        'agg': 'M',
                        'agg_op': 'sum',
                        'date_range':me.dateRange,
                        'sensor_names': ['KW']
                    }
                ))
            }
        }
        promises.push(callAPI('data/',
            {
                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'equipment_name': 'Weather',
                'agg': 'M',
                'agg_op': 'mean',
                'date_range':me.dateRange,
                'sensor_names': [me.oatVar]
            }
        ))
        Promise.all(promises).then(function(reses) {
            let timestamp=null;
            let avgTemp=null;
            let avgTempTS=null;
            let totalPower=null;
            let powerYearData=[];
            for (let res of reses) {
                if(res.data[me.oatVar]){
                    avgTemp=res.data[me.oatVar];
                    avgTempTS=res.data.timestamp;
                }  else {
                    if(!timestamp){
                        timestamp=res.data.timestamp;
                    }
                    if(!totalPower){
                        if(res.data['Comp_Power']){
                            totalPower=res.data['Comp_Power'];
                        } else if (res.data['KW']){
                            totalPower=res.data['KW'];
                        }
                    } else {
                        if(res.data['Comp_Power']){
                            totalPower=me.addArrays(totalPower,res.data['Comp_Power'])
                        } else if (res.data['KW']){
                            totalPower=me.addArrays(totalPower,res.data['KW'])
                        }
                    }
                }
            }
            let dataYears={};
            for (let tindex in timestamp){
                let year=moment(timestamp[tindex]).year()
                if(!dataYears[year]){
                    dataYears[year]={
                        x:[],
                        y:[],
                    }
                }
                dataYears[year].x.push(moment(timestamp[tindex]).format('MMMM'))
                dataYears[year].y.push(totalPower[tindex]);
            }

            for (let year in dataYears){
                powerYearData.push(
                    {x: dataYears[year].x, y: dataYears[year].y, type: 'scattergl' ,name: year},
                );
            }
            me.thisMonthPower=totalPower[totalPower.length-1];
            me.powerYearData=powerYearData;
            //same here, one per year later
            let monthsArray=[ "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December" ];

            let tdataYears={};
            for (let tindex in avgTempTS){
                let year=moment(avgTempTS[tindex]).year()
                if(!tdataYears[year]){
                    tdataYears[year]=[0,0,0,0,0,0,0,0,0,0,0,0]
                }
                let thisone=moment(avgTempTS[tindex]).format('MMMM')
                tdataYears[year][monthsArray.indexOf(thisone)]=avgTemp[tindex]
            }
            let yearsArrayt=[]
            let valuest=[];
            for (let year in tdataYears){
                yearsArrayt.push(year.toString());
                valuest.push(tdataYears[year])
            }
            let currentY=moment().year()
            me.thisYearPower=dataYears[currentY].y.reduce((sum, x) => sum + x,0);
            let colorscaleValue = [
                [0, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
                [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
            ]
            me.layoutHeatmap.yaxis.categoryarray=yearsArrayt
            me.heatmapData = [{
                x: monthsArray,
                y: yearsArrayt,
                z: valuest,
                type: 'heatmap',
                mode: 'markers',
                colorscale: colorscaleValue,
            }]




        });


    }

}
</script>

<style scoped>

</style>
